import { TRUST } from "@/data/site";
import { Icon } from "@/components/common/Icon";
import { Reveal } from "@/components/common/Reveal";

export const TrustBar = () => (
  <section data-testid="trust-bar" className="border-y border-brand-line bg-white">
    <div className="mx-auto grid max-w-[1440px] grid-cols-2 gap-y-8 px-6 py-10 md:grid-cols-3 md:px-12 lg:grid-cols-5 lg:px-20">
      {TRUST.map((t, i) => (
        <Reveal key={t.label} delay={i * 0.06} className="flex items-center gap-3">
          <span className="flex h-11 w-11 items-center justify-center rounded-full bg-brand-blue/10 text-brand-blue">
            <Icon name={t.icon} className="h-5 w-5" />
          </span>
          <span className="text-sm font-semibold leading-tight text-brand-dark">{t.label}</span>
        </Reveal>
      ))}
    </div>
  </section>
);
